import interceptors from "./interceptors/index";

const fetchArticlesByPromotion = (format, promotionCode) => {
  return interceptors({
    url: "/online-promocional/articles",
    method: "GET",
    params: { p_formato: format, p_id_promo: promotionCode },
  });
};

export { fetchArticlesByPromotion };
